import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-[#FAF7F2]" data-id="element-78">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-[#E8F0EC] rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-79" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-80">
        {/* Two-column hero: text + ebook cover */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-81">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-82">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-balance" data-id="element-83">
              Dile Adiós al Dolor de Rodilla en 21 Días
            </h1>
            <p className="text-2xl md:text-3xl font-semibold text-[#C9A84C] mb-8 font-serif italic" data-id="element-84">
              (Sin Cirugías, Inyecciones ni Pastillas)
            </p>

            <h2 className="text-xl md:text-2xl text-[#2D2D2D] leading-relaxed mb-0 font-sans font-medium" data-id="element-85">
              El método de "Lubricación Natural" diseñado específicamente para
              la mujer latina mayor de 65 años en Estados Unidos.
            </h2>
          </div>

          {/* Ebook Image */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-86">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform lg:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/1Rw28f4wRND38SY5kBprS7/rodillassanas.png" alt="Portada del eBook Rodillas Jóvenes" className="w-full h-auto object-cover" data-id="element-88" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl border border-[#E8F0EC] flex items-center gap-3" data-id="element-89">
              <div className="bg-green-100 p-2 rounded-full" data-id="element-90">
                <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-91">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-92" />
                </svg>
              </div>
              <div data-id="element-93">
                <p className="font-bold text-[#1B5E5E]" data-id="element-94">Descarga Inmediata</p>
                <p className="text-sm text-gray-600" data-id="element-95">Acceso de por vida</p>
              </div>
            </div>
          </div>
        </div>

        {/* Transformation image + CTA — full width, centered below the grid */}
        <div className="mt-16 flex flex-col items-center" data-id="element-96">
          <div className="rounded-2xl overflow-hidden shadow-lg border border-[#E8F0EC] max-w-xl w-full" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/oKJE47tgUwNU67fGTqYzGD/section-97569.png" alt="Transformación Rodillas Jóvenes: Antes y Después" className="w-full h-auto object-cover" data-id="element-98" />
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mt-10" data-id="element-99">
            <CTAButton text="Descargar el Protocolo Hoy" href="#precio" data-id="element-100" />
          </div>

          <div className="mt-8 flex items-center gap-4 text-[#1B5E5E] font-medium" data-id="element-101">
            <div className="flex -space-x-2" data-id="element-102">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-[#FAF7F2] bg-[#E8F0EC] flex items-center justify-center text-xs" data-id="element-103">
                  👩🏽‍🦳
                </div>)}
            </div>
            <p className="text-lg" data-id="element-104">
              Únete a cientos de mujeres latinas sin dolor
            </p>
          </div>
        </div>
      </div>
    </section>;
}